export default {"src":"/_next/static/media/apple_logo.9a25a4dc.svg","height":41,"width":121,"blurWidth":0,"blurHeight":0};